export default __webpack_public_path__ + "static/media/videoImage.d42c4b00.png";